angular.module('unica_notification.notification_controllers')

.controller('NotificationEditController', function(
	$rootScope, $scope, $state, $stateParams,
	NotificationEditService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.id       = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.getNotificationTemplateList();

	$scope.$on( 'notification_template_list_loaded', function() {
		$scope.getNotification( $stateParams.id );
	});


	$scope.saveNotification = function()
	{
		$scope.showLoader();

		NotificationEditService
			.update( $scope.notificationData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Notifica aggiornata con successo!', '');

					//$state.go('app.hospitality.room_list', { event_id: $stateParams.event_id });
				}
			});
	};

});